"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: ledeRef,
    isVisible: ledeVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: hairlineRef,
    isVisible: hairlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const headlineLines = ["Delivering Infrastructure Projects with Clarity, Accountability, and Results."];
  return <section data-section-id="19654" id="hero" className="relative h-[720px] max-h-[720px] w-full overflow-hidden bg-[#18334e] px-[23px] text-white">
      <div className="mx-auto flex h-full w-full max-w-[1440px] items-center">
        <div className="grid w-full grid-cols-1 items-center gap-12 md:grid-cols-12">
          <div className="md:col-span-7 flex flex-col">
            <div ref={headlineRef} className="font-default">
              <h1 className="font-default font-semibold text-white" style={{
              fontSize: "clamp(2.5rem, 5vw + 1rem, 5.5rem)",
              letterSpacing: "-0.03em",
              lineHeight: 1.1
            }}>
                {headlineLines.map((line, i) => <span key={i} data-index={i} className="block transition-all" style={{
                opacity: headlineVisible ? 1 : 0,
                transform: headlineVisible ? "translateY(0)" : "translateY(16px)",
                transitionDuration: "500ms",
                transitionTimingFunction: "cubic-bezier(0.2, 0, 0, 1)",
                transitionDelay: `${i * 80}ms`
              }}>Built for Public Good.</span>)}
              </h1>
            </div>

            <div className="mt-12 grid grid-cols-7 gap-6">
              <p ref={ledeRef} className="col-span-7 font-default text-white/80 transition-all !text-4xl md:col-span-6" style={{
              fontSize: "clamp(1.125rem, 0.5vw + 1rem, 1.375rem)",
              lineHeight: 1.5,
              fontWeight: 400,
              opacity: ledeVisible ? 1 : 0,
              transform: ledeVisible ? "translateY(0)" : "translateY(16px)",
              transitionDuration: "500ms",
              transitionTimingFunction: "cubic-bezier(0.2, 0, 0, 1)",
              transitionDelay: "320ms"
            }}>InfraPM helps utilities and local governments identify, pursue, and manage public funding for critical infrastructure projects.</p>
            </div>

            <div ref={ctaRef} className="mt-12 flex flex-col gap-6 transition-all sm:flex-row" style={{
            opacity: ctaVisible ? 1 : 0,
            transform: ctaVisible ? "translateY(0)" : "translateY(16px)",
            transitionDuration: "500ms",
            transitionTimingFunction: "cubic-bezier(0.2, 0, 0, 1)",
            transitionDelay: "440ms"
          }}>
              <Button asChild className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs py-2 has-[>svg]:px-3 h-14 rounded-lg border-none bg-[#80A2B3] px-8 font-medium tracking-wide text-white transition-colors duration-200 !text-xl disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-[#80A2B3]/90">
                <Link to="/ContactPage">Request Consultation</Link>
              </Button>

              <Button asChild variant="outline" className="inline-flex h-14 shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-white/30 px-8 py-2 text-sm font-medium tracking-wide text-white shadow-xs outline-none transition-colors duration-200 !bg-[rgba(128,162,179,1)] hover:bg-white hover:text-[#18334e] focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50">
                
              </Button>
            </div>
          </div>

          <div className="hidden md:block md:col-span-5 relative">
            <div className="aspect-[4/5] max-h-[520px] overflow-hidden rounded-lg">
              <img src="https://infrapm.com/wp-content/uploads/2026/07/Far-West-Texas-Water-Sunset-CGPT2.png" data-wvc-srcset="https://infrapm.com/wp-content/uploads/2026/07/Far-West-Texas-Water-Sunset-CGPT2.png" data-wvc-sizes="https://infrapm.com/wp-content/uploads/2026/07/Far-West-Texas-Water-Sunset-CGPT2.png" alt="Infrastructure planning and project management" className="h-full w-full object-cover grayscale-to-color-image" loading="lazy" decoding="async" />
            </div>
          </div>
        </div>
      </div>

      <div ref={hairlineRef} className="absolute bottom-0 left-0 right-0 mx-auto max-w-[1440px] px-5 md:px-12">
        <div className="h-px origin-left bg-[#B0B0B0]/30 transition-transform" style={{
        transform: hairlineVisible ? "scaleX(1)" : "scaleX(0)",
        transitionDuration: "400ms",
        transitionTimingFunction: "cubic-bezier(0.7, 0, 0.3, 1)"
      }} />
      </div>
    </section>;
}